import React, { Component } from 'react'
import { Header, Container, Box, Text, Button } from './send-email.style'
import { MuvicardService } from '../../../../../services/muvicard.service'
import { getHiddenEmail } from '../../../../../../src/helpers/email.helper'

class SendEmail extends Component {
	constructor(props) {
		super(props)
	}

	redefinePasswordCard = id => {
		this.props.showLoading()
		if (id !== '' || !id) {
			MuvicardService.RedefinePasswordRequest(id).then(data => {
				if (data.data.success) {
					this.props.toastSuccess({
						message:
							'E-mail de redefinição de senha enviado para o seu e-mail com sucesso'
					})
					this.props.hideLoading()
					this.props.nextStep(this.props.step)
				}
			})
		}
	}

	componentDidMount() {
		let { search } = window.location
		if (search) {
			let user = window.location.search
				.match('user=')
				.input.split('=')[1]
				.split('&')[0]
			if (user == this.props.user.id) {
				this.props.nextStep(this.props.step)
			}
		}
	}

	render() {
		const { cardPersonId, user } = this.props
		let hiddenMail = getHiddenEmail(user.email)

		return (
			<Container>
				<Header>
					<h2>Redefinir senha do cartão</h2>
				</Header>
				<Box>
					<Text>
						Essa é a senha utilizada para realizar transações no seu
						cartão.
					</Text>
					<Text>
						Para redefinir sua senha, um código de redefinição será
						enviado para o seu email
						<br />
						<strong>{hiddenMail}</strong>
					</Text>

					<Button
						type="button"
						onClick={() => this.redefinePasswordCard(cardPersonId)}>
						Enviar email de redefinição de senha
					</Button>
				</Box>
			</Container>
		)
	}
}

export default SendEmail
